// extracted by mini-css-extract-plugin
export default {"container":"warn-specialties-chart_container__LGjzI"};